import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import DistributionListManager from '../distribution/DistributionListManager';
import DistributionManager from '../distribution/DistributionManager';
import EventDetail from './EventDetail';
import EventItem from './EventItem';
import EventManager from './EventManager';

function EventPage({ isActive }) {
  const { openMSEventDetail, navigationContext } = useNavigationContext();
  const { accountContext } = useAccountContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [distributionListManagerIsOpen, setDistributionListManagerIsOpen] = useState(false);
  const [distributionManagerIsOpen, setDistributionManagerIsOpen] = useState(false);
  const [distribution, setDistribution] = useState(undefined);
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [duplicatedEvent, setDuplicatedEvent] = useState(undefined);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEventList();
  }, []);

  const fetchEventList = async () => {
    await privateFetch('GET', 'melismes', `/cu/${accountContext.id}/event/`).then((res) => {
      setEventList(res);
    });
  };

  const handleClickEvent = (event) => {
    openMSEventDetail(event);
  };

  useEffect(() => {
    if (navigationContext.acitveEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'melismes',
      `/cu/${accountContext.id}/event/${navigationContext.acitveEventId}/`
    ).then((res) => {
      if (res) {
        setEventDetail(res);
      }
    });
  };

  const handleOpenManager = () => {
    setDuplicationMode(false);
    setDuplicatedEvent(undefined);
    setPanelIsOpen(true);
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'melismes',
      `/cu/${accountContext.id}/event/`,
      "L'évenement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évenement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'melismes',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évenement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };

  const createDistribution = async (distributionForm) => {
    await privateFetch(
      'POST',
      'melismes',
      `/cu/${accountContext.id}/event/${eventDetail.id}/distribution/`,
      'La distribution a bien été ajoutée',
      JSON.stringify(distributionForm)
    ).then(() => {
      fetchEventDetail();
    });
  };

  const updateDistribution = async (distributionForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/distribution/${distribution.id}/`,
      'La distribution a bien été modifiée',
      JSON.stringify(distributionForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setDistributionManagerIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteDistribution = async (distribution) => {
    await privateFetch(
      'DELETE',
      'melismes',
      `/cu/${accountContext.id}/distribution/${distribution.id}/`,
      'La distribution a bien été supprimée'
    ).then(() => {
      fetchEventDetail();
    });
  };

  const handleDistributionOrderChange = async (distributions) => {
    const payload = distributions.map((d, index) => ({
      ...d,
      order: index
    }));
    await privateFetch(
      'PUT',
      'melismes',
      `/cu/${accountContext.id}/event/${eventDetail.id}/distribution/`,
      "L'ordre de la distribution a bien été modifié",
      JSON.stringify(payload)
    ).then(() => {
      fetchEventDetail();
    });
  };

  const goBackEventAction = {
    onClick: handleClickEvent,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évenement',
    icon: 'pi-plus'
  };

  const itemTemplate = (event) => (
    <EventItem
      event={event}
      handleClickEvent={() => handleClickEvent(event)}
      handleDuplicateEvent={() => {
        setDuplicationMode(true);
        setDuplicatedEvent(event);
        setPanelIsOpen(true);
      }}
    />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Évenements"
        labelAction={handleClickEvent}
        action={eventDetail ? goBackEventAction : newEventAction}
        detail={eventDetail}>
        {!eventDetail ? (
          <DataView value={eventList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleUpdateDistribution={(distribution) => {
              setDistributionManagerIsOpen(true);
              setDistribution(distribution);
            }}
            handleUpdateDistributionList={() => setDistributionListManagerIsOpen(true)}
            handleDeleteDistribution={deleteDistribution}
            handleDelete={deleteEvent}
          />
        )}
      </PageWrapper>

      <EventManager
        isOpen={panelIsOpen}
        loading={loading}
        event={duplicationMode ? duplicatedEvent : eventDetail}
        onUpdate={updateEvent}
        onClose={setPanelIsOpen}
        onCreate={createEvent}
        duplicationMode={duplicationMode}
      />

      <DistributionListManager
        isOpen={distributionListManagerIsOpen}
        onClose={setDistributionListManagerIsOpen}
        createDistribution={createDistribution}
        handleOrderChange={handleDistributionOrderChange}
        updateDistribution={updateDistribution}
        distributions={eventDetail?.distributions}
        loading={loading}
      />

      <DistributionManager
        isOpen={distributionManagerIsOpen}
        onClose={setDistributionManagerIsOpen}
        updateDistribution={updateDistribution}
        distribution={distribution}
        loading={loading}
      />
    </div>
  );
}

export default EventPage;
